<template>
  <div id="the-story">
    <div class="story-container">
      <b-container class="story-container-inner">
        <h1>The Story</h1>
        <div class="separator" />
        <p>
          The month of April is dedicated to preserving, restoring and
          protecting Mother Earth.
        </p>
        <p>
          In celebration of Earth Day, these reusable tote bags were crafted
          through the process of upcycling Cubs uniforms and every purchase from
          the collection will benefit Chicago Gateway Green for the express
          purpose of planting new trees around Chicago.
        </p>
        <p>
          Every small step counts. Join us in this effort to make a positive
          impact for future generations to come.
        </p>
        <img
          data-aos="fade-up"
          data-aos-duration="500"
          id="artist-img"
          class="artist-img"
          :src="require('@/assets/images/bg/Penny-Pinch-Artist.png')"
        />
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "TheStory",
  data() {
    return {
      firstPlay: true,
      playing: false,
      ready: false,
    };
  },

  computed: {
    ...mapState(["global"]),
  },
};
</script>

<style lang="scss" scoped>
$video-width: calc((100vh - 100px) * 1.778);

#the-story {
  padding-left: 19px;
  padding-right: 19px;
  overflow: hidden;
  @media (max-width: $md) {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 50px;
  }
  .story-container {
    display: flex;
    background-image: url("~@/assets/images/bg/The-Story-Textured-BG.jpg");
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-position: center;
  }
  .artist-img {
    width: 390px;
    height: auto;
    max-width: 100%;
    margin-top: 50px;
  }
  .story-container-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-top: 93px;
    padding-left: 15px;
    padding-right: 15px;

    @media (max-width: $md) {
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 48px;
    }
    h1 {
      font-family: Poppins-Bold;
      font-size: 34px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 42px;
      text-transform: uppercase;
    }
    .separator {
      width: 115px;
      height: 4px;
      background: #eaeaea;
      margin-top: 15px;
      margin-bottom: 15px;
    }
    p {
      width: 852px;
      max-width: 100%;
      font-family: AvenirNext-Medium;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      line-height: 31px;
      margin-top: 12px;
      width: 750px;
    }
    .no-margin {
      margin: 0 !important;
      width: 750px;
      max-width: 100%;
    }
  }
}
</style>

